import { render, staticRenderFns } from "./EmployeeFingerFormList.vue?vue&type=template&id=e2110b52"
import script from "./EmployeeFingerFormList.vue?vue&type=script&lang=js"
export * from "./EmployeeFingerFormList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports